import { useEffect, useState } from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { AVATAR_PLACEHOLDER_SRC, getUserAvatarUrl } from '../../utilities/userAvatarUrl';

const UserAvatar = ({ user, size = 40, style, className, alt }) => {
  const customSrc = getUserAvatarUrl(user);
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [customSrc]);
  const showCustom = Boolean(customSrc) && !imgFailed;
  const src = showCustom ? customSrc : AVATAR_PLACEHOLDER_SRC;
  const label = alt ?? user?.name ?? 'User';

  return (
    <Avatar
      key={src}
      size={size}
      src={src}
      icon={showCustom ? undefined : <UserOutlined />}
      alt={label}
      style={style}
      className={className}
      onError={() => {
        setImgFailed(true);
        return false;
      }}
    />
  );
};

export default UserAvatar;
